module.exports = __webpack_public_path__ + "images/8b82f31c70c09ece796ae20e60b73b8f.webp";